import { TableHeader, TableRow } from '@cobliteam/ui/components/Table';

import { flexRender, type HeaderGroup } from '@tanstack/react-table';
import { useEffect, useRef } from 'react';
import DataTableHead from '../components/DataTableHead';

interface DataTableHeadProps<TData> {
  getHeaderSize?: (size: number) => void;
  headers: HeaderGroup<TData>[];
  size: number;
}

const DataTableHeader = <TData,>({ headers, getHeaderSize }: DataTableHeadProps<TData>) => {
  const ref = useRef<HTMLTableSectionElement>(null);

  useEffect(() => {
    if (ref.current) getHeaderSize?.(ref.current.clientHeight);
  }, [getHeaderSize]);

  return (
    <TableHeader ref={ref} className='border-gray-6 border-b bg-gray-1' data-testid='datatable-header'>
      {headers.map((headerGroup) => (
        <TableRow key={headerGroup.id} hover={false} className='!bg-transparent'>
          {headerGroup.headers.map((header, index) => {
            return (
              <DataTableHead header={header as any} key={header.id} colSpan={header.colSpan} index={index} alignHeader={header.column.columnDef?.meta?.alignHeader}>
                {flexRender(header.column.columnDef?.header, header.getContext())}
              </DataTableHead>
            );
          })}
        </TableRow>
      ))}
    </TableHeader>
  );
};

export default DataTableHeader;
